import type { Theme } from '@mui/material';

import {
  Box,
  Checkbox,
  FormGroup,
  Typography,
  useMediaQuery,
  FormControlLabel,
} from '@mui/material';

import { Scrollbar } from 'src/components/scrollbar';

export const ParkingFilter = (props: { filters: any; setFilters: React.Dispatch<any> }) => {
  const { filters, setFilters } = props;
  const downSm = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

  const handleChange = (value: string) => {
    const newParking = filters.location.parking === value ? null : value;

    setFilters((prev: any) => ({
      ...prev,
      location: {
        ...prev.location,
        parking: newParking,
      },
    }));
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 1 }}>
        Park Yeri
      </Typography>

      <Scrollbar sx={{ maxHeight: 164 }}>
        <FormGroup>
          <FormControlLabel
            control={
              <Checkbox
                checked={filters.location.parking === 'exists'}
                onChange={() => handleChange('exists')}
                sx={{ py: 0.25 }}
              />
            }
            label="Var"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={filters.location.parking === 'nonExists'}
                onChange={() => handleChange('nonExists')}
                sx={{ py: 0.25 }}
              />
            }
            label="Yok"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={filters.location.parking === 'limited'}
                onChange={() => handleChange('limited')}
                sx={{ py: 0.25 }}
              />
            }
            label="Sınırlı"
          />
        </FormGroup>
      </Scrollbar>
    </Box>
  );
};
